import { HttpClient } from '@angular/common/http';
import { Component, Directive, ElementRef, Input, ViewChild, ViewContainerRef } from '@angular/core';

import { PrismXmlComponent } from '../prism-xml/prism-xml.component';

@Directive({
  // eslint-disable-next-line @angular-eslint/directive-selector
  selector: '[prismXML]'
})
export class PrismXMLDirective {
  constructor(public viewContainerRef: ViewContainerRef) {}
}

@Component({
  selector: 'app-modal',
  templateUrl: './modal.component.html',
  styleUrls: ['./modal.component.scss']
})
export class ModalComponent {
  @Input() xmlURL: string = '';
  @Input() xmlData: string = '';

  @ViewChild('xmlModal') modal!: ElementRef;

  @ViewChild(PrismXMLDirective) prismXML!: PrismXMLDirective;

  constructor(private httpClient: HttpClient) {}

  open(url: string) {
    this.xmlURL = url;

    this.httpClient.get(url, { responseType: 'text' }).subscribe({
      next: (data) => this.loadComponent(data),
      error: (cause) => this.loadComponent(cause.message)
    });

    this.modal.nativeElement.style.display = 'block';
  }

  loadComponent(xmlData: string) {
    const viewContainerRef = this.prismXML.viewContainerRef;
    viewContainerRef.clear();

    const componentRef = viewContainerRef.createComponent<PrismXmlComponent>(PrismXmlComponent);
    componentRef.instance.xmlData = xmlData;
  }

  close() {
    this.modal.nativeElement.style.display = 'none';
  }
}
